import { FC, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

type ExpandableListProps = {
  top?: number;
  title: string;
  items: string[];
};

export const ExpandableList: FC<ExpandableListProps> = ({ title, items, top = 5 }) => {
  const { topItems, restItems } = partition(items, top);
  const [toggle, setToggle] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <li>
        <label className={"text-xs font-bold"}>{title}</label>
      </li>
      <li className={"text-xs"}>{topItems.join(", ")}</li>
      {restItems.length > 0 && (
        <Accordion type="single" collapsible onValueChange={(value) => setToggle(() => value != "")}>
          <AccordionItem value="item">
            <AccordionTrigger className={"py-2 text-xs"}>
              <span className={"flex flex-1 items-center justify-center"}>
                {toggle ? t("collapse_all") : t("show_all")}
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <label className={"text-xs"}>{restItems.join(", ")}</label>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </>
  );
};

type SplitTopAndRestResult<T> = {
  topItems: T[];
  restItems: T[];
};

function partition<T>(array: T[], top: number): SplitTopAndRestResult<T> {
  const topItems = array.slice(0, top);
  const restItems = array.slice(top);
  return { topItems, restItems };
}
